import { render, staticRenderFns } from "./OceanShipping_Component.vue?vue&type=template&id=130be97e&scoped=true&"
import script from "./OceanShipping_Component.vue?vue&type=script&lang=js&"
export * from "./OceanShipping_Component.vue?vue&type=script&lang=js&"
import style0 from "./OceanShipping_Component.vue?vue&type=style&index=0&id=130be97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130be97e",
  null
  
)

export default component.exports